module.exports = __webpack_public_path__ + "static/media/50.9a2eaac2.jpg";